<script setup lang="js">
  import Button from "@/base-components/Button";
  import Vue3Datatable from "@bhplugin/vue3-datatable";
  import {ref} from "vue";
  import {useRouter} from "vue-router";
  import {useI18n} from "vue-i18n";
  import moment from "moment-jalaali";

  const {tickets, isLoading} = defineProps({tickets: {type: Array, required: true}, isLoading: {type: Boolean, default: false}});

  const router = useRouter()
  const {t: $t} = useI18n()

  const cols = [
    {field: "id", title: $t('title.id')},
    {field: "department", title: $t('title.department')},
    {field: "title", title: $t('title.title')},
    {field: "status", title: $t('title.status')},
  ]
  const pageOptions = ref({
    count: 1,
    limit: 10,
    page: 1
  })
  function rowClick(row) {
    router.push(`/ticket/${row.id}`)
  }
</script>

<template>
  <vue3-datatable
    :columns="cols"
    :rows="tickets"
    :loading="isLoading"
    :totalRows="pageOptions.count"
    :isServerMode="true"
    :pageSize="pageOptions.limit"
    :pagination="false"
    :sortable="false"
    class="advanced-table px-4 text-start items-start justify-start"
    rowClass="cursor-pointer"
    @rowClick="rowClick"
  >
    <!-- Empty header slot to remove the header -->
    <template #header>
      <!-- No content here will hide the header -->
    </template>
    <!-- Empty footer slot to remove the footer -->
    <template #footer>
      <!-- No content here will hide the footer -->
    </template>

    <template #department="data, key">
      <div class="text-start">
        {{ data.value?.Department?.name }}
      </div>
    </template>

    <template #id="data, key">
      <div class="text-start">
        {{ data.value.id }}
      </div>
    </template>

    <template #title="data, key">
      <div class="text-start">
        {{ data.value.title }}
      </div>
    </template>
    <template #createdAt="data, key">
      <div class="text-start">
        {{
          data.value.createdAt
            ? moment(data.value.createdAt)
                .locale("fa")
                .format("jYYYY/jMM/jDD HH:mm")
            : "-"
        }}
      </div>
    </template>
    <template #status="data, key">
      <div class="text-start">
        <Button
          :variant="data.value.isOpen ? 'outline-success' : 'outline-warning'"
          size="sm"
          class="inline-block w-16 mb-2 mr-1"
        >
          {{
            !data.value.isOpen
              ? $t("title.close")
              : data.value.status === 0
              ? $t("title.ticket-waiting-for-support")
              : $t("title.ticket-waiting-for-you")
          }}
        </Button>
      </div>
    </template>
  </vue3-datatable>
</template>

<style scoped></style>
